const data = [
    { name: "CDI", id: "CDI" },
    { name: "CDD", id: "CDD" },
    { name: "Freelance", id: "Freelance" },
]
export const contrats = data.sort((a, b) => a.name.localeCompare(b.name));

// A candidate's "contrat" (candidat.status) can hold several values, stored as
// "CDI,Freelance". Older records hold a single value, which stays valid.
export const parseContrats = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (value === null || value === undefined || value === "null") return [];
    return String(value).split(",").map((v) => v.trim()).filter((v) => v && v !== "0");
};

export const serializeContrats = (values) => parseContrats(values).join(",");

export const contratLabel = (id) => contrats.find((c) => c.id === id)?.name || id;
